import { client } from '../client';

export const getStateFromGeocode = async (lat: number, lng: number): Promise<{ state: string }> => {
  const { data } = await client.get<{ state: string }>(`/geolocation/state?lat=${lat}&lng=${lng}`);

  return data;
};
